// {
// "message":"<span style='font-size:20px;'>[price] </span>com cupom <b>INVERNO12</b>",
// "discount":12,
// "countdownEndDate":"2023-06-30T23:59:59",
// "messageColor":"#000000"
// }

class CupomCountdown extends HTMLElement {
  constructor() {
    super();

    this.config = {
      message: this.getAttribute("data-message"),
      discount: parseFloat(this.getAttribute("data-discount")),
      countdownEndDate: this.getAttribute("data-end-datetime"),
      messageColor: this.getAttribute("data-message-color") || "rgb(22, 102, 120)",
    };
    this.productPrice = 0;
    this.productOriginalPrice = 0;
    this.productHandle = null;
    this.productId = 0;
    this.productVaries = false;
    this.isGrid = this.getAttribute("data-is-grid") == "true";
    this.kitSelectedProductHandle = this.getAttribute("data-kit-selected-product-handle");
    this.kitItemQuantity = Number(this.getAttribute("data-kit-item-quantity") ?? 0);
    this.showPixDiscount = JSON.parse(this.getAttribute("data-show-pix-discount") ?? "false");
    this.pixDiscountValue = JSON.parse(this.getAttribute("data-pix-discount-value") ?? "0");
    this.productKitInfo = 0;
    this.productDiscountGrup = false;

    this.priceDiscount = 0;
    this.callAttempt = 0;
    this.nameSessionStorage =
      (typeof window.nameSessionStorage !== "undefined" && window.nameSessionStorage) || "insider:cart:promotionCoupon";
    this.productCollection = this.getAttribute("data-product-collections") || null;
    this.productTags = this.getAttribute("data-product-tags")
      ? this.getAttribute("data-product-tags").split(",")
      : null;
    this.textNotEligible =
      this.getAttribute("data-text-not-elegible") || "Este produto não é elegível para a promoção [name_promotion]";
    // Messages
    this.message = this.querySelector("span.message");

    // Countdown
    this.showCounter = this.getAttribute("data-show-counter") == "true";
    this.countdownFinished = false;
    this.countdownCount = this.querySelector("div.cupom-countdown__count");
    this.endDate = null;
    this.countdownTimer = null;
    this.daysDisplay = this.querySelector("div.days");
    this.hoursDisplay = this.querySelector("div.hours");
    this.minutesDisplay = this.querySelector("div.minutes");
    this.secondsDisplay = this.querySelector("div.seconds");
    this.productVariantPrice = 0;

    // Handle price groups
    this.havePriceGroups = this.dataset.havePriceGroups === "true";
    if (this.havePriceGroups) this.groupProductHandle = this.dataset.groupProductHandle;

    this.verifySessionDiscountCupom();
  }

  verifySessionDiscountCupom() {
    this.callAttempt++;
    const verifySessionDiscountCupom = JSON.parse(sessionStorage.getItem(this.nameSessionStorage));
    if (!verifySessionDiscountCupom || !verifySessionDiscountCupom.data) {
      if (this.callAttempt < 6) {
        setTimeout(this.verifySessionDiscountCupom.bind(this), 300);
      } else {
        if(this.config.message) this.init();
      }
      return;
    }
    this.discountCupom = verifySessionDiscountCupom;
    if(this.discountCupom || this.config.message) this.init();
  }

  init() {
    if (this.havePriceGroups) this.initGroupPrices();
    this.productId = parseInt(this.getAttribute("data-product-id"));
    this.productHandle = this.getAttribute("data-product-handle");
    this.productPrice = parseInt(this.getAttribute("data-product-price"));
    this.productOriginalPrice = parseInt(this.getAttribute("data-product-original-price"));
    this.productVaries = this.getAttribute("data-product-price-varies") == "true";
    this.productKitInfo = this.getAttribute("data-kit-info");

    // wait for price group if it's loading
    if (this.priceAdjustment == undefined && this.havePriceGroups) return;

    // update prices if ther's a price adjustment
    if (this.priceAdjustment) {
      this.productPrice = this.productPrice + this.priceAdjustment;
      this.productOriginalPrice = this.productOriginalPrice + this.markdownAdjustment;
    }

    let show;
    if (this.productKitInfo) {
      this.productKitInfoParsed = Array.from(
        this.productKitInfo
          .split("|")
          .reduce((acc, item) => {
            const [handle, quantity] = item.split(":");
            const qty = parseInt(quantity ?? "1", 10);
            if (acc.has(handle)) acc.get(handle).quantity += qty;
            else acc.set(handle, { handle, quantity: qty });
            return acc;
          }, new Map())
          .values()
      );

      let productKit = this.productKitInfo.split("|");
      let arrayProduct = [],
        arrayQuantity = [];
      let quantity = 0;
      productKit.forEach((productWithQuantity) => {
        productWithQuantity.split(":").forEach((element, index) => {
          if (index === 0) {
            arrayProduct.push(element);
          } else {
            arrayQuantity.push(element);
          }
        });
      });

      let isEqual = true;
      let firstElement = arrayProduct[0];

      for (let i = 1; i < arrayProduct.length; i++) {
        if (arrayProduct[i] != firstElement) {
          isEqual = false;
          break;
        }
      }

      if (isEqual) {
        arrayQuantity.forEach((element) => {
          quantity += parseInt(element);
        });
      }

      // Exibir mensagem com novo preço
      show = this.initPriceText(isEqual, quantity);
    } else {
      show = this.initPriceText(false, 0);
    }
    // Exibir contador
    show = this.initCountdown(show);
    if (show && !this.countdownFinished) {
      this.classList.add("show");
    } else {
      if (!this.discountCupom) {
        this.style.display = "none";
      }else{
        this.classList.add("show");
      }
    }
    this.style.display = "block";
  }

  getMessage() {
    let priceDisplay = [];
    const conditionalPrice = (() => {
      if (this.productVariantPrice > 0) return this.productVariantPrice;
      return this.productPrice;
    })();
    const quantity = (() => {
      if (this.productVariantPrice > 0 && this.kitItemQuantity) return this.kitItemQuantity;
      if (!this.productKitInfoParsed || !this.productKitInfoParsed.length) return 1;
      if (!this.kitSelectedProductHandle) return this.kitItemQuantity || 1;
      return this.productKitInfoParsed.find((item) => this.kitSelectedProductHandle === item.handle)?.quantity || 1;
    })();

    const not_eligible = this.productTags.filter(
      (tag) => tag.indexOf("naoelegivel_" + this.discountCupom.code.toLocaleUpperCase()) >= 0
    );

    if (!not_eligible.length) {
      if (this.discountCupom.discount_config) {
        // const concatUnit = this.kitItemQuantity > 1 ? "/un no kit" : "";
        const concatUnit = "";
        if (this.discountCupom.discount_config.type == "points") {
          if (this.kitItemQuantity > 1 && this.productDiscountGrup) {
            this.config.message =
              "<strong>[price]</strong> pontos" +
              concatUnit +
              " com cupom <b>" +
              this.discountCupom.code.toLocaleUpperCase() +
              "</b>";
          } else {
            this.config.message =
              "Ganhe <strong>[price]</strong> pontos" +
              concatUnit +
              " com cupom <b>" +
              this.discountCupom.code.toLocaleUpperCase() +
              "</b>";
          }
          if (this.discountCupom.discount_config.multiplier_club) {
            this.productDiscountGrup = true;
            this.config.message =
              "Cliente <span style='text-transform: capitalize'>" +
              this.discountCupom.code.toLocaleLowerCase() +
              "</span> ganha pontos com o <span style='color: " +
              this.config.messageColor +
              "'>cupom <b>" +
              this.discountCupom.code.toLocaleUpperCase() +
              "</b></span>";

            this.classList.add("cupom-countdown__club");
            const blockClub = document.createElement("div");
            blockClub.classList.add("club-block");

            const nameGrup_1 =
              this.discountCupom.discount_config.text_grup_2 ?? `TIME ${this.discountCupom.code.toLocaleLowerCase()}`;
            const nameGrup_2 =
              this.discountCupom.discount_config.text_grup_1 ?? `CLUB ${this.discountCupom.code.toLocaleLowerCase()}`;

            blockClub.innerHTML = `
            <div class="cupom-countdown__item-club">
             <p>${nameGrup_1}:</p>
             <p><strong>${Math.round(
               this.discountCupom.discount_config.multiplier_club * (conditionalPrice / 100)
             ).toLocaleString("pt-BR")} PONTOS</strong></p>
            </div>
            <div class="cupom-countdown__item-club">
             <p>${nameGrup_2}:</p>
             <p><strong>${Math.round(
               this.discountCupom.discount_config.multiplier * (conditionalPrice / 100)
             ).toLocaleString("pt-BR")} PONTOS</strong></p>
            </div>
          `;
            if (this.querySelector(".club-block")) {
              this.querySelector(".club-block").remove();
            }
            this.appendChild(blockClub);
          }

          // priceDisplay = this.discountCupom.discount_config.multiplier * (this.productPrice / 100);
          // if(this.kitItemQuantity > 1) {
          this.priceDiscount = Math.round(this.discountCupom.discount_config.multiplier * (conditionalPrice / 100));
          priceDisplay.push(this.priceDiscount.toLocaleString("pt-BR"));
          // }
        } else if (this.discountCupom.discount_config.type == "cashback") {
          this.config.message =
            "<strong>[price]</strong> de cashback" +
            // concatUnit +
            " com <b>" +
            this.discountCupom.code.toLocaleUpperCase() +
            "</b>";

          // priceDisplay = this.formatMoneyCountdown(
          //   this.productPrice * (this.discountCupom.discount_config.multiplier / 100)
          // );

          // if(this.kitItemQuantity > 1) {
          this.priceDiscount = (conditionalPrice / 1) * (this.discountCupom.discount_config.multiplier / 100);
          priceDisplay.push(this.formatMoneyCountdown(this.priceDiscount));
          // }
        }

        this.style.display = "block";
      } else if (this.discountCupom.data) {
        // const price_rule = this.discountCupom.price_rule;
        const price_rule = this.discountCupom.data.discount;
        let isProduct = false;
        if (price_rule.target_type == "line_item" && price_rule.value_type == "percentage") {
          let isCollection = true;
          if (price_rule.allocation_method == "each" && price_rule.target_selection == "entitled") {
            isCollection = false;
            isProduct = false;
            if (this.productCollection) {
              const filterCollection = this.productCollection.split(",").map((collection) => parseInt(collection));
              for (const collection of filterCollection) {
                if (price_rule.entitled_collection_ids.includes(collection)) {
                  isCollection = true;
                  break;
                }
              }
              if (price_rule.entitled_product_ids.includes(this.productId)) {
                isProduct = true;
              }
            }
          }

          if (isCollection || isProduct) {
            const price = conditionalPrice * (1 - (price_rule.value * -1) / 100);
            this.priceDiscount = Math.round(price);
            priceDisplay.push(this.formatMoneyCountdown(price));
            if (this.kitItemQuantity > 1) {
              priceDisplay[0] = this.formatMoneyCountdown(Math.round(price) / quantity) + "/un no kit";
            }
          }
        } else if (price_rule.target_type == "line_item" && price_rule.value_type == "fixed_amount") {
          if (price_rule.entitled_product_ids.includes(this.productId)) {
            isProduct = true;
            const price = conditionalPrice + parseInt(price_rule.value) * 100;
            priceDisplay.push(this.formatMoneyCountdown(price));
          }
        }

        if (priceDisplay.length && !this.discountCupom.code.includes("PIX_3%_OFF_EXTRA"))
          this.config.message =
            "<strong>[price]</strong> com cupom <b>" + this.discountCupom.code.toLocaleUpperCase() + "</b>";

        if (price_rule.target_type == "line_item" && price_rule.value_type == "fixed_amount") {
          // SET DEFAULT DISCOUNT MESSAGE IN THIS CASES
          const price = conditionalPrice * (1 - this.config.discount / 100);
          priceDisplay.push(this.formatMoneyCountdown(price));
        }

        if (!isProduct && price_rule.entitled_product_ids.length) {
          const price = conditionalPrice * (1 - this.config.discount / 100);
          priceDisplay.push(this.formatMoneyCountdown(price));
        }

        if (this.discountCupom.code.includes("PIX_3%_OFF_EXTRA")) {
          const price = conditionalPrice * (1 - this.config.discount / 100);
          priceDisplay[0] = this.formatMoneyCountdown(price);
        }

        if (this.showPixDiscount && !this.config.message.includes("no pix")) {
          this.config.message = this.config.message.replace(
            "com cupom",
            `(no pix <strong>${this.formatMoneyCountdown(
              parseInt(priceDisplay[0].replace("R$", "")) * 100 * (1 - this.pixDiscountValue / 100)
            )}</strong>) com cupom`
          );
        }

        if(!this.parentElement.querySelector('.calc-prices__container')){
          this.style.display = "block";
        }
      }
    } else {
      const block_message = this.querySelector(".cupom-countdown__message");
      if (block_message) {
        block_message.classList.add("hide-svg");
      }
      this.config.message = this.textNotEligible.replace(
        "[name_promotion]",
        this.discountCupom.code.toLocaleUpperCase()
      );
    }
    return priceDisplay;
  }

  updateProductPrice(price) {
    this.dataset.productPrice = price;
    this.productPrice = price;
  }

  initPriceText(isEqual, quantity) {
    try {
      let price,
        priceDisplay = [],
        displayMessageCountdownDefault = false;

      if (this.config && this.config.message && this.config.discount && this.productPrice > 0) {
        displayMessageCountdownDefault = true;
      }
      let discountFlag =
        this.closest(".card-wrapper")?.querySelector("discount-flag") ??
        this.closest("product-info")?.querySelector("discount-flag");
      const discountFlagMobile = this.closest(".product")?.querySelector("#reviews discount-flag");

      if(this.kitSelectedProductHandle != ""){
        discountFlag = this.closest("kit-item")?.querySelector("discount-flag");
      }

      //TODO: [MSGCUPOM][INICIO] Descomentar para reativar
      if (!this.discountCupom || !this.discountCupom.data) {
        if (displayMessageCountdownDefault) {
          if (isEqual) {
            price = this.productPrice * (1 - this.config.discount / 100);
            priceDisplay.push(this.formatMoneyCountdown(Math.round(price)) + "");
          } else {
            price = this.productPrice * (1 - this.config.discount / 100);
            priceDisplay.push(this.formatMoneyCountdown(price));
          }

          // price = this.productPrice * (1 - this.config.discount / 100);
          // priceDisplay.push(this.formatMoneyCountdown(price));
        }
      } else {
        priceDisplay = this.getMessage();

        if (!priceDisplay) {
          this.discountCupom = null;
          this.init();
          return false;
        }
      }

      if (discountFlag && !this.discountCupom?.discount_config?.type) {
        if (price || this.priceDiscount > 0) {
          discountFlag.style.display = "block";
          discountFlag.updateDiscountFlag(this.productOriginalPrice, price || this.priceDiscount);

          if (discountFlagMobile) {
            discountFlagMobile.style.display = "block";
            discountFlagMobile.updateDiscountFlag(this.productOriginalPrice, price || this.priceDiscount);
          }
        }
      }
      //TODO: [MSGCUPOM] [FIM] Descomentar para reativar
      let messageDisplay = this.config.message.replace("[price]", priceDisplay[0]);

      if (
        !messageDisplay.includes("pontos") &&
        !messageDisplay.includes("cashback") &&
        this.showPixDiscount &&
        priceDisplay[0]
      ) {
        messageDisplay.replace(
          "com cupom",
          `(no pix <strong>${this.formatMoneyCountdown(
            parseInt(priceDisplay[0].replace("R$", "")) * 100 * (1 - this.pixDiscountValue / 100)
          )}</strong>) com cupom`
        );
      }
      this.message.innerHTML = messageDisplay;
      if (this.isGrid) {
        this.message.childNodes.forEach((element) => {
          if (element.nodeName == "SPAN") {
            element.style.fontSize = "inherit";
          }
        });
      }

      if (this.config.messageColor && !this.discountCupom?.discount_config?.multiplier_club) {
        this.message.style.color = this.config.messageColor;
      }

      if (this.productVaries) {
        const isAffiliateCoupon =
          this.discountCupom?.discount_config &&
          (this.discountCupom?.discount_config.type == "points" ||
            this.discountCupom?.discount_config.type == "cashback");
        if (this.productKitInfo && this.kitItemQuantity > 1 && !this.productDiscountGrup && !isAffiliateCoupon) {
          this.message.innerHTML = "a partir de " + this.message.innerHTML;
        }

        document.addEventListener("variant:changed", () => {
          const _priceSpan = document.querySelector(".ProductMeta__Price");
          if (_priceSpan) {
            try {
              const nProductPrice = parseInt(_priceSpan.innerHTML.replace("R$ ", "")) * 100;
              const nPrice = nProductPrice * (1 - this.config.discount / 100);
              const nPriceDisplay = this.formatMoneyCountdown(nPrice);

              this.message.innerHTML = this.config.message.replace("[price]", nPriceDisplay);
            } catch (error) {
              console.log(error);
            }
          }
        });
      }
      if (priceDisplay) {
        return true;
      }
    } catch (error) {
      console.log("Error: show countdown message");
      console.log(error);
      return false;
    }
  }

  updatePriceText(variant) {
    if (!variant || !variant.price) return;
    const variantPrice = this.priceAdjustment ? variant.price + this.priceAdjustment : variant.price;

    this.productVariantPrice = variantPrice;
    let priceDisplay = [];
    //TODO: [MSGCUPOM] [INICIO] Descomentar para reativar
    if (!this.discountCupom || !this.discountCupom.data) {
      if (this.config && this.config.message && this.config.discount && this.productVariantPrice > 0) {
        const price = this.productVariantPrice * (1 - this.config.discount / 100);
        priceDisplay.push(this.formatMoneyCountdown(price));
        if (this.kitItemQuantity > 1) {
          priceDisplay.push(this.formatMoneyCountdown(Math.round(price) / this.kitItemQuantity) + "/un no kit");
        }
      }
    } else {
      priceDisplay = this.getMessage();
      const discountFlag = this.closest(".card-wrapper")?.querySelector("discount-flag");
      if (discountFlag && !this.discountCupom?.discount_config?.type) {
        if (this.productVariantPrice || this.priceDiscount > 0) {
          discountFlag.style.display = "flex";
          discountFlag.style.justifyContent = "flex-end";
          const promotion = JSON.parse(sessionStorage.getItem(this.nameSessionStorage));
          if (
            promotion &&
            !promotion?.discount_config?.type &&
            promotion.data &&
            promotion.data?.discount?.value_type !== "fixed_amount"
          ) {
            const priceDiscount = variantPrice * (1 - (promotion.data.discount.value * -1) / 100);
            discountFlag.updateDiscountFlag(variant.compare_at_price, priceDiscount);
          } else if (
            promotion &&
            !promotion?.discount_config?.type &&
            promotion.data &&
            promotion.data?.discount?.value_type === "fixed_amount"
          ) {
            const priceDiscount = variant.compare_at_price * (1 - this.config.discount / 100);
            discountFlag.updateDiscountFlag(variantPrice, priceDiscount);
          } else {
            discountFlag.updateDiscountFlag(this.productOriginalPrice, this.priceDiscount);
          }
        }
      }
    }

    //TODO: [MSGCUPOM] [FIM] Descomentar para reativar

    let messageDisplay = this.config.message.replace("[price]", priceDisplay[0]);
    if (
      !messageDisplay.includes("pontos") &&
      !messageDisplay.includes("cashback") &&
      this.showPixDiscount &&
      priceDisplay[0]
    ) {
      messageDisplay.replace(
        "com cupom",
        `(no pix <strong>${this.formatMoneyCountdown(
          parseInt(priceDisplay[0].replace("R$", "")) * 100 * (1 - this.pixDiscountValue / 100)
        )}</strong>) com cupom`
      );
    }
    this.message.innerHTML = messageDisplay;
    if (this.isGrid) {
      this.message.childNodes.forEach((element) => {
        if (element.nodeName == "SPAN") {
          element.style.fontSize = "inherit";
        }
      });
    }
  }

  initCountdown(show) {
    try {
      if (!this.discountCupom && this.config && this.config.countdownEndDate) {
        this.endDate = Date.parse(this.config.countdownEndDate);
        this.showRemaining();
        if (this.showCounter && this.countdownCount) this.countdownCount.classList.add("show");
        this.countdownTimer = setInterval(this.showRemaining.bind(this), 1000);

        return true;
      }
    } catch (error) {
      console.log("Error: show countdown count");
      console.log(error);
    }
    return show;
  }

  showRemaining() {
    const _SECOND = 1000;
    const _MINUTE = _SECOND * 60;
    const _HOUR = _MINUTE * 60;
    const _DAY = _HOUR * 24;

    const now = new Date();
    const distance = this.endDate - now;
    if (distance < 0) {
      clearInterval(this.countdownTimer);
      this.countdownFinished = true;
      this.classList.remove("show");
      return;
    }
    if (!this.showCounter) {
      clearInterval(this.countdownTimer);
      return;
    }

    const days = Math.floor(distance / _DAY);
    const daysSplit = `${days}`.split("");
    const hours = Math.floor((distance % _DAY) / _HOUR);
    const hoursSplit = `${hours}`.split("");
    const minutes = Math.floor((distance % _HOUR) / _MINUTE);
    const minutesSplit = `${minutes}`.split("");
    const seconds = Math.floor((distance % _MINUTE) / _SECOND);
    const secondsSplit = `${seconds}`.split("");

    if (this.daysDisplay) {
      if (days > 0) {
        this.daysDisplay.innerHTML = `${days < 10 ? "<p>0</p>" : `<p>${daysSplit[0]}</p>`}${
          days < 10 ? `<p>${daysSplit[0]}</p>` : `<p>${daysSplit[1]}</p>`
        }`;
      } else {
        this.daysDisplay.classList.add("hide");
      }
    }

    if (this.hoursDisplay) {
      this.hoursDisplay.innerHTML = `${hours < 10 ? "<p>0</p>" : `<p>${hoursSplit[0]}</p>`}${
        hours < 10 ? `<p>${hoursSplit[0]}</p>` : `<p>${hoursSplit[1]}</p>`
      }`;
    }

    if (this.minutesDisplay) {
      this.minutesDisplay.innerHTML = `${minutes < 10 ? "<p>0</p>" : `<p>${minutesSplit[0]}</p>`}${
        minutes < 10 ? `<p>${minutesSplit[0]}</p>` : `<p>${minutesSplit[1]}</p>`
      }`;
    }

    if (this.secondsDisplay) {
      this.secondsDisplay.innerHTML = `${seconds < 10 ? "<p>0</p>" : `<p>${secondsSplit[0]}</p>`}${
        seconds < 10 ? `<p>${secondsSplit[0]}</p>` : `<p>${secondsSplit[1]}</p>`
      }`;
    }
  }

  formatMoney(cents) {
    const value = Math.round(cents / 100)
      .toFixed(2)
      .replace(".", ",");
    return `R$ ${value.replace(/\B(?=(\d{3})+(?!\d))/g, ".")}`;
  }

  formatMoneyCountdown(price) {
    const priceNoDecimals = this.formatMoney(price).split(",")[0];
    const priceDisplay = `R$${priceNoDecimals.split("$")[1]}`;

    return priceDisplay;
  }

  getProductMetafields() {
    if (!window.showCupomCountdown || window.showCupomCountdown === "false") return;
    try {
      fetch(`/products/${this.productHandle}?view=metafields`)
        .then((res) => res.text())
        .then((html) => {
          this.config = JSON.parse(html)["countdown"];

          // Exibir mensagem com novo preço
          let show = this.initPriceText();
          // Exibir contador
          show = this.initCountdown(show);
          if (show && !this.countdownFinished) {
            this.classList.add("show");
          }
        });
    } catch (error) {
      console.log(error);
    }
  }

  /* Start price group handling */
  initGroupPrices() {
    try {
      const productHandle = this.groupProductHandle;
      // check if price group cookies are set
      const priceGroupCookie = this.getPriceGroupCookie(productHandle);

      if (priceGroupCookie === "loading" || !priceGroupCookie) return this.setupPriceGroupListeners();
      if (priceGroupCookie.groupId === "default") return;

      this.priceAdjustment = priceGroupCookie.priceAdjustment;
      this.markdownAdjustment = priceGroupCookie.markdownAdjustment;
      
    } catch (e) {
      console.error(">>>", e);
      this.priceAdjustment = 0;
      this.markdownAdjustment = 0;
    }
  }

  setupPriceGroupListeners() {
    document.addEventListener(`${this.productHandle}-price-group-loaded`, ({ detail }) => {
      this.priceAdjustment = detail.priceAdjustment;
      this.markdownAdjustment = detail.markdownAdjustment;
      this.init();
    });
  }

  getPriceGroupCookie(productHandle) {
    const cookieName = `statsig-group-${productHandle}`;
    const cookieValue = document.cookie
      .split("; ")
      .find((row) => row.startsWith(cookieName))
      ?.split("=")[1];

    if (cookieValue === "loading") return "loading";
    if (!cookieValue) return null;
    return JSON.parse(cookieValue);
  }
  /* End price group handling */
}
customElements.define("cupom-countdown", CupomCountdown);
